import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';

class SMReservationEditViewCorpName extends React.Component {

  textFieldDidEndEditing(e) {
    this.props.delegate.changeCorpName(e.currentTarget.name, e.currentTarget.value);
  }

  render() {
    const reservation = this.props.reservation;

    return (
      <td>
        <SMFormTextField
          name="reserved_user[corp_name]"
          value={reservation.user ? reservation.user.corp_name : ''}
          options={{className: 'w400'}}
          placeholderText="株式会社スペースマーケット" delegate={this} />
      </td>
    );
  }
}

SMReservationEditViewCorpName.propTypes = {
  reservation: PropTypes.object.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewCorpName;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewCorpName.jsx